import { Component, h } from 'preact'

import DropdownSearchbox from '../DropdownSearchbox'
import SingleItemList from './SingleItemList'
import { Item, ItemsList } from '../interfaces'

interface Props {
    items: ItemsList,
    hasSearch: boolean,
    classes: string
}

interface State {
    isOpen: boolean,
    items: ItemsList
}

class DropdownItemList extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      isOpen: true,
      items: props.items
    }
    this.changeItemsToDisplay = this.changeItemsToDisplay.bind(this)
  }

    changeItemsToDisplay = (newItemList: ItemsList) => {
      this.setState({ items: newItemList })
    }

    componentDidUpdate (previousProps: Readonly<Props>): void {
      if (previousProps.items !== this.props.items) {
        this.setState({ items: this.props.items })
      }
    }

  render (props: Props, state: State) {
      const { classes, hasSearch, items: fullList } = props
      const { isOpen, items } = state

      if (!isOpen) return null

      return (
        <div class={classes}>
          { hasSearch && <DropdownSearchbox items={fullList} onChange={this.changeItemsToDisplay} isOpen={state.isOpen} /> }
          { items.length === 0 && <div class='empty-list-message'>No results found</div> }
          { items.length > 0 && items.map((item: Item) => <SingleItemList item={item} onClick={() => this.setState({ isOpen: false })} />) }
        </div>
      )
    }
}

export default DropdownItemList
